import React from "react";

const MessageRowPlaceholder = () => (
	<div className="messages-messagerow messages-messagerow--placeholder">
		<div className="messages-messagerow-photo" />
		<div className="messages-messagerow-main">
			<div className="messages-messagerow-main-top-line">
				<div className="messages-messagerow-main-top-line-aboutuser">
					<span className="messages-messagerow-main-top-line-aboutuser-username" />
				</div>
			</div>
			<div className="messages-messagerow-main-snippet" />
		</div>
	</div>
);

export default MessageRowPlaceholder;



// WEBPACK FOOTER //
// ./src/apps/messages/components/MessageRowPlaceholder.jsx